import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../src/assets/iconfont.js'
import VueClipboard from 'vue-clipboard2'
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'

/* 引入全局过滤器 */
import * as fliterCommon from '../src/utils/common'
Object.keys(fliterCommon).forEach(key => Vue.filter(key, fliterCommon[key]));

/* 引入全局指令focus */
Vue.directive('focus', {
  inserted: function (el) {
    el.focus();
  }
})

/* scroll全局置底指令scroll */
import scrollDirective from '../src/utils/scroll';
Vue.directive('scroll', scrollDirective)

Vue.use(Vuex);
Vue.use(ElementUI)
Vue.use(VueClipboard)
Vue.use(VueVideoPlayer, {
  
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store,
})
